module.exports = __webpack_public_path__ + "img/RBS04_2.76b1a31f.jpg";